import { useEffect, useMemo, useState, useCallback } from "react";
import api from "../api/api";
import Table from "../components/Table";
import Pagination from "../components/Pagination";
import ConfirmModal from "../components/ConfirmModal";
import CommonModal from "../components/CommonModal";
import InputField from "../components/InputField";
import Button from "../components/Button";
import SearchIcon from "@mui/icons-material/Search";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import "./InputPurchases.css";
 
const INPUT_TYPES = [
  { value: "Seeds", label: "Seeds" },
  { value: "Fertilizers", label: "Fertilizers" },
  { value: "Pesticides", label: "Pesticides" },
  { value: "Equipment", label: "Equipment" },
  { value: "Other", label: "Other" },
];
 
const UNITS = [
  { value: "kg", label: "kg" },
  { value: "bags", label: "bags" },
  { value: "liters", label: "liters" },
  { value: "pieces", label: "pieces" },
  { value: "quintal", label: "quintal" },
];
 
const InputPurchases = () => {
  const [inputs, setInputs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
 
 
 
 
 
  const [products, setProducts] = useState([]);
const [selectedProduct, setSelectedProduct] = useState("");
 
 
 
const fetchProducts = async () => {
  try {
    const res = await api.get("/products");
 
    setProducts(res.data.products || []);
  } catch (error) {
    console.error("Product fetch error:", error);
  }
};
useEffect(() => {
  fetchProducts();
}, []);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
 
const fetchCategories = useCallback(async () => {
    try {
      const res = await api.get("/categories");

      const formatted = res.data.categories.map((cat) => ({
        value: cat.id,
        label: cat.category_name,
      }));

      setCategories(formatted);
    } catch (error) {
      console.error("Category fetch error:", error);
    }
  }, []);

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);
 
  const [purchaseDate, setPurchaseDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  });
  const [inputType, setInputType] = useState("");
  const [itemName, setItemName] = useState("");
  const [quantity, setQuantity] = useState("");
  const [unit, setUnit] = useState("");
  const [rate, setRate] = useState("");
  const [product, setProduct ] = useState("");
  const [supplierName, setSupplierName] = useState("");
  const [purchaseDateError, setPurchaseDateError] = useState("");
 
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedInputType, setSelectedInputType] = useState("");
 
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
 
  const [isEditMode, setIsEditMode] = useState(false);
  const [editInputId, setEditInputId] = useState(null);
  const [selectedInputId, setSelectedInputId] = useState(null);
 
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
 
  const getToken = () => localStorage.getItem("token");
 
  const fetchInputs = useCallback(async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (selectedInputType) params.append("inputType", selectedInputType);
      if (searchTerm) params.append("search", searchTerm);
 
      const res = await api.get(`/inputs?${params.toString()}`, {
        headers: { Authorization: `Bearer ${getToken()}` },
      });
      setInputs(res.data?.inputs || []);
    } catch {
      setError("Failed to fetch input purchases");
    } finally {
      setLoading(false);
    }
  }, [selectedInputType, searchTerm]);
 
  useEffect(() => {
    fetchInputs();
  }, [fetchInputs]);
 
  const calculateTotal = (qty, r) => {
    const q = parseFloat(qty) || 0;
    const r_val = parseFloat(r) || 0;
    return (q * r_val).toFixed(2);
  };
 
  const handleSaveInput = async () => {
    if (
      !purchaseDate ||
      !inputType ||
      !itemName ||
      !quantity ||
      !unit ||
      !rate
 
    ) {
      setError("All required fields must be filled");
      return;
    }
 
    const payload = {
      purchase_date: purchaseDate,
      input_type: inputType,
      item_name: itemName,
      quantity: parseFloat(quantity),
      unit: unit,
      rate: parseFloat(rate),
      total_amount: parseFloat(calculateTotal(quantity, rate)),
      supplier_name: supplierName || null,
      category_id: null,
      product_id: selectedProduct ? Number(selectedProduct) : null,
    };
 
    try {
      if (isEditMode) {
        await api.put(`/inputs/${editInputId}`, payload, {
          headers: { Authorization: `Bearer ${getToken()}` },
        });
        setSuccessMessage("Input purchase updated successfully");
      } else {
        await api.post("/inputs", payload, {
          headers: { Authorization: `Bearer ${getToken()}` },
        });
        setSuccessMessage("Input purchase added successfully");
      }
 
      setShowSuccessModal(true);
      resetForm();
      fetchInputs();
    } catch {
      setError("Failed to save input purchase");
    }
  };
 
  const resetForm = () => {
    const today = new Date().toISOString().split("T")[0];
    setPurchaseDate(today);
    setInputType("");
    setItemName("");
    setQuantity("");
    setUnit("");
    setRate("");
    setSupplierName("");
    setIsEditMode(false);
    setEditInputId(null);
    setShowModal(false);
    setError("");
  };
 
  const handleEditClick = (input) => {
    setIsEditMode(true);
    setEditInputId(input.id);
    setPurchaseDate(input.purchase_date);
    setInputType(input.input_type);
    setItemName(input.item_name);
    setQuantity(String(input.quantity));
    setUnit(input.unit);
    setRate(String(input.rate));
    setSupplierName(input.supplier_name || "");
    setShowModal(true);
  };
 
  const handleDeleteClick = (id) => {
    setSelectedInputId(id);
    setShowConfirm(true);
  };
 
  const confirmDelete = async () => {
    try {
      await api.delete(`/inputs/${selectedInputId}`, {
        headers: { Authorization: `Bearer ${getToken()}` },
      });
      setSuccessMessage("Input purchase deleted successfully");
      setShowSuccessModal(true);
      fetchInputs();
    } catch {
      setError("Failed to delete input purchase");
    } finally {
      setShowConfirm(false);
    }
  };
 
  const filteredInputs = useMemo(() => inputs, [inputs]);
 
  const totalItems = filteredInputs.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
 
  const paginatedData = useMemo(() => {
    const start = (currentPage - 1) * itemsPerPage;
    return filteredInputs.slice(start, start + itemsPerPage);
  }, [filteredInputs, currentPage, itemsPerPage]);
 
  const columns = [
    { label: "Item Name", accessor: "item_name" },
    { label: "Input Type", accessor: "input_type" },
    {
      label: "Quantity",
      render: (row) => `${row.quantity} ${row.unit}`,
    },
    {
      label: "Rate (₹)",
      accessor: "rate",
      render: (row) => `₹${row.rate}`,
    },
    {
      label: "Total (₹)",
      accessor: "total_amount",
      render: (row) => `₹${row.total_amount}`,
    },
    { label: "Supplier", accessor: "supplier_name" },
    {
      label: "Date",
      accessor: "purchase_date",
      render: (row) => {
        const date = new Date(row.purchase_date);
        return date.toLocaleDateString("en-GB");
      },
    },
    {
      label: "Actions",
      render: (row) => (
        <div className="d-flex gap-2 justify-content-center">
          <EditIcon
            sx={{ cursor: "pointer", color: "#6b7280" }}
            onClick={() => handleEditClick(row)}
          />
          <DeleteIcon
            sx={{ cursor: "pointer", color: "#6b7280" }}
            onClick={() => handleDeleteClick(row.id)}
          />
        </div>
      ),
    },
  ];
 
  return (
    <>
      {error && <div className="alert alert-danger">{error}</div>}
 
      <div className="row mb-3">
        <div className="col-md-8 d-flex">
          <div className="position-relative flex-grow-1">
            <input
              type="search"
              className="form-control extrapdng"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <SearchIcon
              style={{
                position: "absolute",
                left: "12px",
                top: "50%",
                transform: "translateY(-50%)",
                color: "#6b7280",
                width: "16px",
                height: "16px",
              }}
            />
          </div>
        </div>
        <div className="col-md-2 d-flex">
          <select
            className="form-select custom-select"
            value={selectedInputType}
            onChange={(e) => setSelectedInputType(e.target.value)}
          >
            <option value="">All Types</option>
            {INPUT_TYPES.map((t) => (
              <option key={t.value} value={t.value}>
                {t.label}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-2 d-flex">
          <Button onClick={() => setShowModal(true)} btncls="w-100 m-0">
            + Add Purchase
          </Button>
        </div>
      </div>
 
      <Table
        columns={columns}
        data={paginatedData}
        loading={loading}
        emptyMessage="No input purchases found"
        pagination={
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            onPageChange={setCurrentPage}
            onItemsPerPageChange={(v) => {
              setItemsPerPage(v);
              setCurrentPage(1);
            }}
          />
        }
      />
 
      {showModal && (
        <>
          <div className="modal fade show d-block bg-dark bg-opacity-50">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content p-4">
                <h5 className="mb-3">
                  {isEditMode ? "Edit Purchase" : "Add Purchase"}
                </h5>
 
                <InputField
                  label="Item Name"
                  placeholder="Enter item name"
                  value={itemName}
                  onChange={(e) => setItemName(e.target.value)}
                  inpcls="mb-3"
                />
 
                <label className="form-label">Input Type</label>
                <select
                  className="form-select mb-3 custom-select"
                  value={inputType}
                  onChange={(e) => setInputType(e.target.value)}
                >
                  <option value="">Select Type</option>
                  {INPUT_TYPES.map((t) => (
                    <option key={t.value} value={t.value}>
                      {t.label}
                    </option>
                  ))}
                </select>
                {/*
                <label className="form-label">Date</label>
                <input
                  type="date"
                  className="form-control mb-3"
                  value={purchaseDate}
                  onChange={(e) => setPurchaseDate(e.target.value)}
                /> */}
                <label className="form-label">Date</label>
                <div className="mb-3 w-100 position-relative">
                  <DatePicker
                    selected={purchaseDate ? new Date(purchaseDate) : null}
                    onChange={(date) => {
                      const formatted = date
                        ? date.toISOString().split("T")[0]
                        : "";
                      setPurchaseDate(formatted);
                    }}
                    dateFormat="dd/MM/yyyy"
                    className={`form-control w-100 ${purchaseDateError ? "is-invalid" : ""}`}
                    placeholderText="DD/MM/YYYY"
                  />
 
                  <CalendarMonthIcon
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      pointerEvents: "none",
                      color: "#6c757d",
                    }}
                  />
                </div>
 
                <div className="row mb-3">
                  <div className="col-6 d-flex flex-column">
                    <InputField
                      label="Quantity"
                      placeholder="Qty"
                      type="number"
                      value={quantity}
                      onChange={(e) => setQuantity(e.target.value)}
                    />
                  </div>
                  <div className="col-6 d-flex flex-column">
                    <label className="form-label">Unit</label>
                    <select
                      className="form-select custom-select"
                      value={unit}
                      onChange={(e) => setUnit(e.target.value)}
                    >
                      <option value="">Select Unit</option>
                      {UNITS.map((u) => (
                        <option key={u.value} value={u.value}>
                          {u.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
 
                <div className="row mb-3">
                  <div className="col-6 d-flex flex-column">
                    <InputField
                      label="Rate (₹)"
                      placeholder="Rate"
                      type="number"
                      value={rate}
                      onChange={(e) => setRate(e.target.value)}
                    />
                  </div>
 
                  <div className="row mb-3">
                    <div className="col-6 d-flex flex-column">
                    <label className="form-label">Category</label>
                    <select
                      className="form-select custom-select"
                      value={selectedCategory}
                      onChange={(e) => setSelectedCategory(e.target.value)}
                    >
                      <option value="">Select Category</option>
                      {categories.map((cat) => (
                        <option key={cat.value} value={cat.value}>
                          {cat.label}
                        </option>
                      ))}
                    </select>
                    </div>
{/*
                      <div className="col-6 d-flex flex-column">
                    <InputField
                      label="Product"
                      placeholder="Product"
                      type="text"
                      value={product}
                      onChange={(e) => setProduct(e.target.value)}
                    />
                  </div> */}
 
                  <div className="col-6 d-flex flex-column">
  <label className="form-label">Product</label>
  <select
    className="form-select"
    value={selectedProduct}
    onChange={(e) => setSelectedProduct(e.target.value)}
  >
    <option value="">Select Product</option>
    {products.map((p) => (
      <option key={p.id} value={p.id}>
        {p.product_name}
      </option>
    ))}
  </select>
</div>
                  </div>
                  <div className="col-6 d-flex flex-column">
                    <InputField
                      label="Total (₹)"
                      placeholder="Total"
                      value={calculateTotal(quantity, rate)}
                      disabled
                    />
                  </div>
                </div>
 
                <InputField
                  label="Supplier (Optional)"
                  placeholder="Enter supplier name"
                  value={supplierName}
                  onChange={(e) => setSupplierName(e.target.value)}
                />
 
                <div className="d-flex justify-content-end gap-2 mt-4">
                  <Button
                    variant="secondary"
                    btncls="bg-secondary m-0"
                    onClick={resetForm}
                  >
                    Cancel
                  </Button>
                  <Button onClick={handleSaveInput} btncls="m-0">
                    {isEditMode ? "Update" : "Save"}
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}
 
      {showConfirm && (
        <ConfirmModal
          show={showConfirm}
          title="Delete Purchase"
          message="Are you sure you want to delete this purchase?"
          confirmText="Yes, Delete"
          onConfirm={confirmDelete}
          onCancel={() => setShowConfirm(false)}
        />
      )}
 
      <CommonModal
        show={showSuccessModal}
        title="Success"
        onClose={() => setShowSuccessModal(false)}
        footer={
          <Button
            variant="primary"
            text="OK"
            onClick={() => setShowSuccessModal(false)}
            btncls="m-0"
          />
        }
      >
        <p>{successMessage}</p>
      </CommonModal>
    </>
  );
};
 
export default InputPurchases;